import {Heading} from "../../components";
import React, {Suspense} from "react";
import {useTranslation} from "react-i18next";
import ServicesTabs from "../ServicesTabs";

export default function  Services() {

    const {t} = useTranslation();

    const FeatureTabsGrid =[
        {
            tabsNumber: "01",
            title: t("main.ourServices.cardTitle.1"),
            description: t("main.ourServices.cardDescription.1"),
            icon: "/images/services_1.svg",
        },
        {
            tabsNumber: "02",
            title: t("main.ourServices.cardTitle.2"),
            description: t("main.ourServices.cardDescription.2"),
            icon: "/images/services_2.svg",
        },
        {
            tabsNumber: "03",
            title: t("main.ourServices.cardTitle.3"),
            description: t("main.ourServices.cardDescription.3"),
            icon: "/images/services_3.svg",
        },{
            tabsNumber: "04",
            title: t("main.ourServices.cardTitle.4"),
            description: t("main.ourServices.cardDescription.4"),
            icon: "/images/services_4.svg",
        },
        {
            tabsNumber: "05",
            title: t("main.ourServices.cardTitle.5"),
            description: t("main.ourServices.cardDescription.5"),
            icon: "/images/services_5.svg",
        },
        {
            tabsNumber: "06",
            title: t("main.ourServices.cardTitle.6"),
            description: t("main.ourServices.cardDescription.6"),
            icon: "/images/services_6.svg",
        },
    ];

    return (
        <>
            <section id="Services">
                <div className="flex flex-col items-center px-6 sm:px-[16px]">
                    <div className="container-xs flex flex-col items-start gap-10">
                        <Heading
                            size="desktop_heading_4"
                            as="h2"
                            className="font-medium text-[#191c2fe5] leading-[33.6px] gap-4 uppercase">
                            {t("main.ourServices.headTitle")}
                        </Heading>
                        <div className="grid lg:grid-cols-3 grid-cols-1 gap-5 sm:gap-4 self-stretch">
                            <Suspense fallback={<div>Loading </div>}>
                                {FeatureTabsGrid.map((d, index) => (
                                    <ServicesTabs {...d} key={"grid" + index}/>
                                ))}
                            </Suspense>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}